<template>
    <div class="automation-item entry" @click="$emit('click', $event)"
    :class="{'locked':!is('automations')}">
        <div class="img-wrap">
            <img class="placeholder-img" v-if="!item.icon" src="@/assets/img/placeholder-img.svg">
            <img v-else :src="'data:image/png;base64,'+item.icon">
        </div>
        <div class="text flex" >
            <strong>{{ title }}</strong>
            <p>{{ item.action }} <b>{{ item.action_caption }}</b></p>
        </div>
	    <v-button class="" extra-small red border @click.stop="$emit('delete', item)"
	              :icon="require('@/assets/img/trash.svg')" />
    </div>
</template>

<script>

import {is} from "@/helpers/roles";
import VButton from "@/components/base/v-button";

export default {
  name: "AutomationEntry", components: {VButton}, props: ['item', 'title'],

	methods:{
  	is(role){
  		return is(role)
	  }
	}
}
</script>

<style lang="scss" scoped>
.automation-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #F6F9FE;
	border-radius: 8px;
	padding: 10px 25px;
	cursor: pointer;
	position: relative;

	.left {
		display: flex;
		align-items: center;
	}

	strong {
		font-weight: 500;
		font-size: 14px;
		line-height: 150%;
		letter-spacing: 0.02em;
		color: $darker-grey;
		display: block;
		margin-bottom: 3px;
	}

	p {
		font-size: 13px;
		line-height: 150%;
		letter-spacing: 0.02em;
		margin: 0;
		color: #636A7B;
	}

	.img-wrap {
		display: flex;
		margin-right: 15px;
	}

	&.locked {
		opacity: 0.7;
		pointer-events: none;
		.delete-icon {
			opacity: 0.5;
		}
	}
	.img-wrap {
		max-width: 70px;
		img {
			width: 30px;
		}
	}
}
</style>
